<template>
  <div>
    <side-menu
      :title="regionSelectTitle"
      :value="open"
      @side-menu:click-close="onClose"
    >
      <search-list-select
        ref="search-list"
        v-model="selectedValues.region"
        class="filters-place__regions mb-1"
        :items="regionItems"
        :search="showSearch"
        mandatory
        @search="handleSearch"
      >
        <template #list-item-content="{ item }">
          <v-list-item-content
            :class="{ 'filters-place__metro': item.data.color }"
            :style="{ 'color': item.data.color || 'initial' }"
          >
            <v-list-item-title
              class="filters-place__region-name text-body-1 text--text"
            >
              {{ item.text }}
            </v-list-item-title>
          </v-list-item-content>
        </template>
      </search-list-select>

      <div class="filters-place__buttons">
        <v-button
          color="text-secondary"
          :disabled="!active && !innerFiltersActive && !searchedByName"
          depressed
          text
          light
          @click="reset"
        >
          <span class="text-button">Сбросить</span>
        </v-button>

        <v-button
          class="ml-4"
          color="primary"
          depressed
          :disabled="!innerFiltersActive"
          :data-filters-yandex-goals="yandexGoalName"
          @click="submit"
        >
          <span class="text-button">Показать</span>
        </v-button>
      </div>
    </side-menu>
  </div>
</template>

<script>
import VButton from 'www/vue_components/common/core/VButton.vue'
import DialogManager from 'www/vue_components/common/mixins/DialogManager'
import SearchListSelect from 'www/vue_components/desktop/SearchListSelect/SearchListSelect.vue'
import SideMenu from 'www/vue_components/desktop/core/SideMenu.vue'

export default {
  name: 'CommonFiltersPlace',
  components: {
    SearchListSelect,
    VButton,
    SideMenu,
  },
  mixins: [
    DialogManager,
  ],
  model: {
    prop: 'filters',
    event: 'change',
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    filters: {
      type: Object,
      default: () => ({}),
    },
    active: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      selectedValues: {
        region: '',
      },
      searchedByName: false,
    }
  },
  computed: {
    innerFiltersActive() {
      return this.selectedValues.region !== this.filters.region.value
    },
    regionSelectTitle() {
      return this.regionItems.find(region => region.data.regionType === 'station') ? 'Метро или район' : 'Район'
    },
    showSearch() {
      return this.regionItems.length >= 10
    },
    regionItems() {
      return this.makeListItems(this.filters.region)
    },
    yandexGoalName() {
      if (this.type === 'lpu') {
        return 'filter-lpu-list-result-show'
      }

      if (this.type === 'doctor') {
        return 'filter-doctor-list-result-show'
      }

      return ''
    },
  },
  watch: {
    filters: {
      deep: true,
      immediate: true,
      handler() {
        this.innerReset()
      },
    },
  },
  methods: {
    handleSearch(query) {
      this.searchedByName = !!query
    },
    onClose() {
      this.$emit('filters:close')
      this.innerReset()
    },
    innerReset() {
      this.selectedValues.region = this.filters.region.value
    },
    reset() {
      if (this.searchedByName) {
        this.$refs['search-list'].resetSearch()
      }

      if (this.active) {
        this.$emit('filters:reset')

        return
      }

      this.innerReset()
    },
    submit() {
      this.$emit('filters:submit', this.selectedValues)
      this.$emit('filters:close')
    },
    makeListItems(filter) {
      return filter.type.getList().map(filterOption => ({
        value: filterOption.value,
        id: filterOption.value,
        text: filterOption.name,
        data: filterOption.data,
      }))
    },
  },
}
</script>

<style lang="scss" scoped>
.filters-place {
  display: flex;
  flex-flow: column nowrap;

  &__buttons {
    margin-top: auto;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  &__metro {
    display: flex;
    align-items: center;

    &::before {
      content: '';
      width: 8px;
      height: 8px;
      margin-right: 8px;
      background-color: currentColor;
      border-radius: 50%;
    }
  }

  &__regions {
    flex: 1 1 auto;
    min-height: 0;
  }

  &__region-name {
    flex-basis: 0;
  }
}
</style>
